import React from "react";
import {AppointmentForm} from "../Form/AppointmentForm";

export function AppointmentFormMessage({text}: ({ text: string })): React.ReactElement {

    return (<AppointmentForm text={text}/>);
}
